export const developmentLicenceKey = 'kurtiscool';